//@ts-nocheck
import React from 'react';
import { Button } from './ui/button';
import { Card } from './ui/Card';

interface AccessibilityCommitmentCardProps {
  headline: string;
  subheadline: string;
  content: {
    title: string;
    items: string[];
  }[];
  ctaText: string;
  onCtaClick: () => void;
}

export const AccessibilityCommitmentCard: React.FC<AccessibilityCommitmentCardProps> = ({
  headline,
  subheadline,
  content,
  ctaText,
  onCtaClick,
}) => {
  return (
    <Card className="overflow-hidden max-w-4xl mx-auto">
      <div className="bg-gray-800 text-white p-6">
        <h2 className="text-2xl font-bold mb-2">{headline}</h2>
        <p className="text-gray-300">{subheadline}</p>
      </div>
      <div className="p-6">
        {content.map((section, index) => (
          <div key={index} className="mb-6 last:mb-0">
            <h3 className="text-xl font-semibold mb-3">{section.title}</h3>
            <ul className="list-disc pl-5 space-y-2">
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} className="text-gray-700">{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    
    </Card>
  );
};

